// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as $$Promise from "../../../../node_modules/@ryyppy/rescript-promise/lib/es6_global/src/Promise.bs.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function playWithRetries(onMute, el) {
  var retry = function (attempt) {
    return $$Promise.$$catch(el.play().then(function (param) {
      return Promise.resolve(undefined);
    }), function (e) {
      var muted = el.muted;
      if (attempt === 1 && !muted) {
        Belt_Option.forEach(onMute, function (onMute) {
          Curry._1(onMute, true);
        });
        el.muted = true;
      }
      if (attempt < 6) {
        return retry(attempt + 1 | 0);
      } else {
        return Promise.resolve(undefined);
      }
    });
  };
  return retry(0);
}
export { playWithRetries };
/* No side effect */